import { OrgTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadCurrentOrg = createAction('[Org] Load Current Org', props<{ username: string }>());

export const loadCurrentOrgSuccess = createAction(
  '[Org] Load Current Org Success',
  props<{ org: OrgTypes.Organization }>()
);

export const loadCurrentOrgFailure = createAction('[Org] Load Current Org Failure', props<{ error: any }>());

export const loadReportOwner = createAction(
  '[Org] Load Report Owner',
  props<{
    username: string;
  }>()
);

export const loadReportOwnerSuccess = createAction(
  '[Org] Load Report Owner Success',
  props<{ org: OrgTypes.Organization }>()
);

export const loadReportOwnerFailure = createAction('[Org] Load Report Owner Failure', props<{ error: any }>());
